import * as React from 'react';
export const ripplingSvg = React.forwardRef(function ripplingSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M8.405 12.66c0-1.65-.838-3.015-2.405-4.16h3.642a5.212 5.212 0 0 1 2.062 4.16 5.212 5.212 0 0 1-2.062 4.158c1.182.491 1.856 1.691 1.856 3.41V23.5H8.199v-3.273c0-1.636-.783-2.782-2.199-3.409 1.567-1.145 2.405-2.509 2.405-4.159Zm7.148 0c0-1.65-.839-3.015-2.406-4.16h3.643a5.212 5.212 0 0 1 2.061 4.16 5.212 5.212 0 0 1-2.061 4.158c1.182.491 1.855 1.691 1.855 3.41V23.5h-3.299v-3.273c0-1.636-.783-2.782-2.199-3.409 1.567-1.145 2.406-2.509 2.406-4.159Zm7.148 0c0-1.65-.838-3.015-2.405-4.16h3.642A5.212 5.212 0 0 1 26 12.66a5.212 5.212 0 0 1-2.062 4.158c1.182.491 1.856 1.691 1.856 3.41V23.5h-3.299v-3.273c0-1.636-.783-2.782-2.2-3.409 1.568-1.145 2.406-2.509 2.406-4.159Z',
    }),
  );
});
ripplingSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var rippling = {
  category: 'brand',
  colorable: false,
  name: 'rippling',
  svg: ripplingSvg,
};
